import { useCallback, useMemo } from "react";

interface IUseLocalStorageFlagOptions {
  key: string;
}

interface IUseLocalStorageFlagReturn {
  isExist: boolean;
  setItem: () => void;
}

export function useLocalStorageFlag({
  key,
}: IUseLocalStorageFlagOptions): IUseLocalStorageFlagReturn {
  const isExist = useMemo(() => {
    return localStorage.getItem(key) === "true";
  }, [key]);

  const setItem = useCallback(() => {
    localStorage.setItem(key, "true");
  }, [key]);

  return {
    isExist,
    setItem,
  };
}
